module.exports = __webpack_public_path__ + "images/category_lp/furniture/store_images/2@2x_1d0b4d1a1fd8dd3a19f0594ae1bf4e87.png";